module.exports = __webpack_public_path__ + "img/ic_pin.8ecd37c6.svg";